<app-entity-profile-card
  *ngIf="company"
  [name]="company.name"
  [picture]="company.picture"
>
  <app-entity-follow-header
    profileTitle
    [name]="company.name"
    [active]="isTopicSaved"
    [ignored]="isCompanyIgnored"
    [allowIgnore]="true"
    [labels]="shortcutLabels"
    [activeLabel]="companyLabel"
    [isLoading]="isSavingCompany"
    (toggled)="handleSaveCompany(company)"
    (ignoreToggled)="handleIgnoreCompany($event)"
    (labelToggled)="handleCompanyLabel($event)"
  ></app-entity-follow-header>
  <ul
    class="entity-profile__contacts"
    profileContacts
    aria-label="Contact links"
  >
    <li *ngIf="company.webSiteUrl">
      <a [href]="company.webSiteUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-globe" aria-hidden="true"></i><span>Website</span>
      </a>
    </li>
    <li *ngIf="company.twitterUrl">
      <a [href]="company.twitterUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-twitter" aria-hidden="true"></i><span>X</span>
      </a>
    </li>
    <li *ngIf="company.linkedInUrl">
      <a [href]="company.linkedInUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-linkedin" aria-hidden="true"></i><span>LinkedIn</span>
      </a>
    </li>
    <li *ngIf="company.youTubeUrl">
      <a [href]="company.youTubeUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-youtube" aria-hidden="true"></i><span>YouTube</span>
      </a>
    </li>
    <li *ngIf="company.financial">
      <a [href]="company.financial" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-money-bill" aria-hidden="true"></i
        ><span>Financial</span>
      </a>
    </li>
    <li *ngIf="company.streetAddress && company.locationUrl">
      <a [href]="company.locationUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-map-marker" aria-hidden="true"></i
        ><span>{{ company.city }}</span>
      </a>
    </li>
  </ul>
</app-entity-profile-card>

<!-- Related topics & companies -->
<div class="related-panels">
  <section class="related-panel" *ngIf="relatedCompanies?.length">
    <h3 class="related-panel__title">Related Companies & Products</h3>
    <div class="related-panel__links">
      <a
        *ngFor="let rCompany of relatedCompanies"
        href="javascript:;"
        role="button"
        (click)="onDisplayRelatedCompanyContent(rCompany)"
        class="a-button-link"
        >{{ rCompany?.name }}</a
      >
    </div>
  </section>
  <section class="related-panel" *ngIf="relatedTopics?.length">
    <h3 class="related-panel__title">Related Topics</h3>
    <div class="related-panel__links">
      <a
        *ngFor="let rTopic of relatedTopics"
        href="javascript:;"
        role="button"
        (click)="onDisplayRelatedTopicContent(rTopic)"
        class="a-button-link"
        >{{ rTopic?.name }}</a
      >
    </div>
  </section>
</div>

<!-- Coverage chart section -->
<div class="coverage-chart-section p-d-flex p-mt-4">
  <div
    class="coverage-chart-link pointer"
    (click)="goToExploreRelatedCoverage(company)"
  >
    <span *ngIf="coveragePastYearText">
      <h6>Coverage of {{ company.name }} in the past year</h6>
      <div id="chart-2" *ngIf="longTermChart">
        <app-long-term-chart [topic]="longTermChart"></app-long-term-chart>
      </div>
      <p>{{ coveragePastYearText }}</p>
    </span>
  </div>
</div>
<hr />
<div class="content-heading">
  <div>
    <label style="font-size: large"
      >Recent content matching {{ company.name }}</label
    >
  </div>
  <div class="content-heading__action">
    <p-button
      class="p-button-sm coverage view-all-button"
      type="button"
      icon="pi pi-search"
      label="View all coverage of {{ company.name }}"
      (click)="goToExploreRelatedCoverage(company)"
    ></p-button>
  </div>
</div>
<app-content-items
  [parentName]="parentName"
  [items]="contentItems"
  [loading]="!loading"
  [pageSize]="companyContentPageSize"
  [page]="currentPage"
  [total]="companyContentTotal"
  [keywords]="searchBody?.keywords"
></app-content-items>

<div id="paginator" class="p-d-flex p-jc-between">
  <div>
    <p-paginator
      #pp
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ companyContentTotal | number }} total items"
      [pageLinkSize]="3"
      [showFirstLastIcon]="false"
      (onPageChange)="getPage($event)"
      [rows]="companyContentPageSize"
      [totalRecords]="companyContentTotal"
    >
    </p-paginator>
  </div>
  <div></div>
  <div id="sort">
    <app-sort-options
      (sortChangesEmiter)="sortChange($event)"
      [defaultSort]="sortSelected"
    ></app-sort-options>
  </div>
</div>
